import { HasAssetDescriptors } from './AssetBase';

export enum TransactionEntryType {
  DEBIT = 'Debit',
  CREDIT = 'Credit',
  NONE = 'None',
}

export enum TransactionType {
  UNKNOWN = 'Unknown',
  BALANCEFORWARDASSET = 'BalanceForwardAsset',
  BALANCEFORWARDSETUPFEES = 'BalanceForwardSetupFees',
  BALANCEFORWARDANNUALFEES = 'BalanceForwardAnnualFees',
  BALANCEFORWARDTRANSACTIONFEES = 'BalanceForwardTransactionFees',
  BALANCEFORWARDOTHERAGENCYFEES = 'BalanceForwardOtherAgencyFees',
  THIRDPARTYSETUPFEEDUE = 'ThirdPartySetupFeeDue',
  THIRDPARTYANNUALFEEDUE = 'ThirdPartyAnnualFeeDue',
  THIRDPARTYTRANSACTIONFEEDUE = 'ThirdPartyTransactionFeeDue',
  THIRDPARTYOTHERFEEDUE = 'ThirdPartyOtherFeeDue',
  SETUPFEEDUE = 'SetupFeeDue',
  ANNUALFEEDUE = 'AnnualFeeDue',
  TRANSACTIONFEEDUE = 'TransactionFeeDue',
  OTHERFEEDUE = 'OtherFeeDue',
  REIMBURSEDSETUPFEES = 'ReimbursedSetupFees',
  REIMBURSEDANNUALFEES = 'ReimbursedAnnualFees',
  REIMBURSEDTRANSACTIONFEES = 'ReimbursedTransactionFees',
  REIMBURSEDOTHERAGENCYFEES = 'ReimbursedOtherAgencyFees',
  PAYMENTSETUPFEES = 'PaymentSetupFees',
  PAYMENTANNUALFEES = 'PaymentAnnualFees',
  PAYMENTTRANSACTIONFEES = 'PaymentTransactionFees',
  PAYMENTOTHERAGENCYFEES = 'PaymentOtherAgencyFees',
  PAYMENTACCOUNTEXPENSE = 'PaymentAccountExpense',
  DEPOSIT = 'Deposit',
  INITIALCONTRIBUTION = 'InitialContribution',
  SEPEMPLOYERCONTRIBUTION = 'SEPEmployerContribution',
  NONDEDUCTIBLECONTRIBUTION = 'NonDeductibleContribution',
  ROTHCONVERSIONAMOUNT = 'RothConversionAmount',
  ROLLOVER = 'Rollover',
  TRANSFERIN = 'TransferIn',
  SUBSEQUENTCONTRIBUTION = 'SubsequentContribution',
  PROCEEDSFROMDISTRIBUTIONORPAYOFF = 'ProceedsfromDistributionOrPayoff',
  PROCEEDSFROMSALEOFPARTNERSHIP = 'ProceedsfromSaleofPartnership',
  MONEYMARKETANDDIVIDEND = 'MoneyMarketAndDividend',
  UNKNOWNDEPOSITTRANSFER = 'UnknownDepositTransfer',
  DISBURSEMENT = 'Disbursement',
  ASSETSPURCHASE = 'AssetsPurchase',
  REDEMPTIONOFMONEYMARKETFUNDSHARES = 'RedemptionOfMoneyMarketFundShares',
  GAINORLOSSONMONEYMARKETFUNDSHARES = 'GainOrLossOnMoneyMarketFundShares',
  CASHTRANSFERTOBENEFICIARY = 'CashTransferToBeneficiary',
  CASHTRANSFERTOCHARITY = 'CashTransferToCharity',
  INCOMETAXWITHHELD = 'IncomeTaxWithheld',
  CASHTRANSFERTONEWCUSTODIAN = 'CashTransferToNewCustodian',
  CASHINVESTORWITHDRAWAL = 'CashInvestorWithdrawal',
  SHARESPURCHASE = 'SharesPurchase',
  SHARESROTHCONVERSION = 'SharesRothConversion',
  SHARESROLLOVERIN = 'SharesRolloverIn',
  SHARESTRANSFERINFROMOUTSIDEACCOUNT = 'SharesTransferInFromOutsideAccount',
  SHARESADJUSTMENT = 'SharesAdjustment',
  SHARESCONTRIBUTIONOFADDITIONALCAPITAL = 'SharesContributionofAdditionalCapital',
  SHARESDISTRIBUTIONREINVESTED = 'SharesDistributionReInvested',
  SHARESTRANSFEROUTTOBENEFICIARY = 'SharesTransferOutToBeneficiary',
  SHARESTRANSFERCASHTOCHARITY = 'SharesTransferCashToCharity',
  SHARESTRANSFEROUTTOOUTSIDEACCOUNT = 'SharesTransferOutToOutsideAccount',
  SHARESINVESTORWITHDRAWAL = 'SharesInvestorWithdrawal',
  SHARESSALE = 'SharesSale',
  SHARESGAINORLOSSONSALE = 'SharesGainOrLossOnSale',
  SHARESDISSOLUTION = 'SharesDissolution',
  SHARESDISTRIBUTION = 'SharesDistribution',
  SHARESINTERNALTRANSFERIN = 'SharesInternalTransferIn',
  SHARESINTERNALTRANSFEROUT = 'SharesInternalTransferOut',
  NOTEPURCHASE = 'NotePurchase',
  NOTEROTHCONVERSION = 'NoteRothConversion',
  NOTEROLLOVERIN = 'NoteRolloverIn',
  NOTETRANSFERIN = 'NoteTransferIn',
  NOTEINTERESTEARNEDANDREINVESTED = 'NoteInterestEarnedandReInvested',
  NOTETRANSFEROUTTOBENEFICIARY = 'NoteTransferOutToBeneficiary',
  NOTETRANSFERCASHTOCHARITY = 'NoteTransferCashToCharity',
  NOTETRANSFEROUT = 'NoteTransferOut',
  NOTEINVESTORWITHDRAWAL = 'NoteInvestorWithdrawal',
  NOTEREPAYMENTOFPRINCIPLE = 'NoteRepaymentOfPrinciple',
  NOTEGAINORLOSSONSALE = 'NoteGainOrLossOnSale',
  NOTELIQUIDATION = 'NoteLiquidation',
  NOTEPAYMENTOFINTEREST = 'NotePaymentOfInterest',
  NOTEINTERNALTRANSFERIN = 'NoteInternalTransferIn',
  NOTEINTERNALTRANSFEROUT = 'NoteInternalTransferOut',
  DOLLARBASEDASSETPURCHASE = 'DollarBasedAssetPurchase',
  DOLLARBASEDASSETADJUSTMENT = 'DollarBasedAssetAdjustment',
  DOLLARBASEDASSETROTHCONVERSION = 'DollarBasedAssetRothConversion',
  DOLLARBASEDASSETROLLOVERIN = 'DollarBasedAssetRolloverIn',
  DOLLARBASEDASSETTRANSFERIN = 'DollarBasedAssetTransferIn',
  DOLLARBASEDASSETCONTRIBUTIONOFADDITIONALCAPITAL = 'DollarBasedAssetContributionOfAdditionalCapital',
  DOLLARBASEDASSETINCOMEREINVESTED = 'DollarBasedAssetIncomeReInvested',
  DOLLARBASEDASSETTRANSFEROUTTOBENEFICIARY = 'DollarBasedAssetTransferOutToBeneficiary',
  DOLLARBASEDASSETTRANSFERCASHTOCHARITY = 'DollarBasedAssetTransferCashToCharity',
  DOLLARBASEDASSETTRANSFEROUT = 'DollarBasedAssetTransferOut',
  DOLLARBASEDASSETINVESTORWITHDRAWAL = 'DollarBasedAssetInvestorWithdrawal',
  DOLLARBASEDASSETSALE = 'DollarBasedAssetSale',
  DOLLARBASEDASSETGAINORLOSSONSALE = 'DollarBasedAssetGainOrLossOnSale',
  DOLLARBASEDASSETASSETDISSOLUTION = 'DollarBasedAssetAssetDissolution',
  DOLLARBASEDASSETASSETDISTRIBUTION = 'DollarBasedAssetAssetDistribution',
  DOLLARBASEDASSETINTERNALTRANSFERIN = 'DollarBasedAssetInternalTransferIn',
  DOLLARBASEDASSETINTERNALTRANSFEROUT = 'DollarBasedAssetInternalTransferOut',
}

export interface Transaction extends HasAssetDescriptors {
  date: string;
  description: string;
  accountNumber: string;
  accountType: string;
  amount: number;
  balance?: number;
  entryType: TransactionEntryType;
  accountStatus: string;
  units?: number;
  totalUnits?: number;
  assetType?: string;
  depositClearDate?: string;
  transactionType?: TransactionType;
}
